import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-devices",
  "use": "icon-devices-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-devices\"><title></title><path d=\"M972.91,148H53.09A52.09,52.09,0,0,0,1,200.09v95.82A52.09,52.09,0,0,0,53.09,348H972.91A52.09,52.09,0,0,0,1025,295.91V200.09A52.09,52.09,0,0,0,972.91,148ZM194,294a47,47,0,1,1,47-47A47,47,0,0,1,194,294Zm151,0a47,47,0,1,1,47-47A47,47,0,0,1,345,294Z\" /><path d=\"M972.91,680H53.09A52.09,52.09,0,0,0,1,732.09v95.82A52.09,52.09,0,0,0,53.09,880H972.91A52.09,52.09,0,0,0,1025,827.91V732.09A52.09,52.09,0,0,0,972.91,680ZM194,826a47,47,0,1,1,47-47A47,47,0,0,1,194,826Zm151,0a47,47,0,1,1,47-47A47,47,0,0,1,345,826Z\" /><path d=\"M972.91,414H53.09A52.09,52.09,0,0,0,1,466.09v95.82A52.09,52.09,0,0,0,53.09,614H972.91A52.09,52.09,0,0,0,1025,561.91V466.09A52.09,52.09,0,0,0,972.91,414ZM194,560a47,47,0,1,1,47-47A47,47,0,0,1,194,560Zm151,0a47,47,0,1,1,47-47A47,47,0,0,1,345,560Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/devices.svg
// module id = ZPPV
// module chunks = 54